import { render, staticRenderFns } from "./SeletorOpcoesImpressão.vue?vue&type=template&id=5996907c"
import script from "./SeletorOpcoesImpressão.vue?vue&type=script&lang=ts&setup=true"
export * from "./SeletorOpcoesImpressão.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports